import { z } from "zod"

const EnvSchema = z.object({
  VITE_NODE_ENV: z.string().default("development"),
  VITE_API_URL: z.string().url(),
  VITE_CRM_URL: z.string().url(),
  VITE_FIREBASE_API_KEY: z.string(),
  VITE_FIREBASE_AUTH_DOMAIN: z.string(),
  VITE_FIREBASE_PROJECT_ID: z.string(),
  VITE_FIREBASE_STORAGE_BUCKET: z.string(),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string(),
  VITE_FIREBASE_APP_ID: z.string(),
  VITE_FIREBASE_AUTH_EMULATOR_HOST: z.string().optional(),
  VITE_SENTRY_DSN: z.string().optional(),
})

const parsed = EnvSchema.safeParse(import.meta.env)

if (!parsed.success) {
  console.error("❌ Invalid ENV:")
  console.error(parsed.error.flatten().fieldErrors)
  throw new Error("Invalid ENV")
}

const env = parsed.data

export default env
